import { Box, Flex, BoxProps, Text, Icon, Center } from "@chakra-ui/react";
import { CheckIcon } from "components/vectors/check-icon";
import { useState } from "react";

export function Stepper({
  children,
  steps,
  stepperContainerProps,
}: {
  children: (props: {
    activeStep: number;
    goToNext: () => void;
    goToPrevious: () => void;
  }) => any;
  steps: { title: string; containerProps?: BoxProps }[];
  stepperContainerProps?: BoxProps;
}) {
  const [activeStep, setActiveStep] = useState(0);

  function goToNext() {
    setActiveStep((prev) => (prev < steps.length ? prev + 1 : prev));
  }

  function goToPrevious() {
    setActiveStep((prev) => (prev > 0 ? prev - 1 : prev));
  }

  return (
    <Box w="100%">
      <Flex justify="space-between" w="100%" {...stepperContainerProps}>
        {steps.map((step, index) => (
          <Flex
            key={step.title}
            direction="column"
            align="center"
            flex="1"
            position="relative"
          >
            <Center
              w="2rem"
              h="auto"
              aspectRatio="1"
              borderRadius="full"
              bg={activeStep >= index ? "primary.400" : "gray.200"}
              color={activeStep >= index ? "white" : "gray.500"}
              zIndex="1"
            >
              {activeStep > index ? (
                <Icon as={CheckIcon} boxSize={4} />
              ) : (
                <Text fontSize="sm">{index + 1}</Text>
              )}
            </Center>

            <Text
              mt={2}
              fontSize="xs"
              textAlign="center"
              color={activeStep >= index ? "primary.400" : "gray.500"}
              fontWeight={activeStep >= index ? "medium" : "normal"}
            >
              {step.title}
            </Text>

            {index < steps.length - 1 && (
              <Box
                position="absolute"
                top="1rem"
                left="50%"
                transform="translateX(0)"
                w="full"
                h="2px"
                bg={activeStep > index ? "blue.600" : "gray.200"}
              />
            )}
          </Flex>
        ))}
      </Flex>

      {children({ goToNext, goToPrevious, activeStep })}
    </Box>
  );
}
